export default __webpack_public_path__ + "static/media/CivilEng_Icon-03.9e28ce93.png";